import request from '@/utils/request'

export function notifyFailedPayment(uuid) {
    return request.post('/payments/' + uuid + '/notify-error');
}